import { render, staticRenderFns } from "./IncomingCampaigns.vue?vue&type=template&id=2f41bf74&scoped=true"
import script from "./IncomingCampaigns.vue?vue&type=script&lang=ts"
export * from "./IncomingCampaigns.vue?vue&type=script&lang=ts"
import style0 from "./IncomingCampaigns.vue?vue&type=style&index=0&id=2f41bf74&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f41bf74",
  null
  
)

export default component.exports